import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryTagItemCount = createRoutine(
  'FETCH_INVENTORY_TAG_ITEM_COUNT'
);
